export default __webpack_public_path__ + "resources/icons/d442-0db2.webp";